import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _startsWithInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/starts-with";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { Children, cloneElement, useState, useEffect, useRef, useCallback } from 'react';
import ReactDOM from 'react-dom';
import { Manager, Popper, Reference } from 'react-popper';
import { StyleSheet, styled, text, useToken } from '@rexlabs/styling';
import { noop } from 'lodash';
var defaultStyles = StyleSheet({
  popout: {
    paddingTop: function paddingTop(_ref) {
      var token = _ref.token;
      return token('popout.padding.top', token('spacing.s', '.8rem'));
    },
    paddingRight: function paddingRight(_ref2) {
      var token = _ref2.token;
      return token('popout.padding.right', token('spacing.s', '.8rem'));
    },
    paddingBottom: function paddingBottom(_ref3) {
      var token = _ref3.token;
      return token('popout.padding.bottom', token('spacing.s', '.8rem'));
    },
    paddingLeft: function paddingLeft(_ref4) {
      var token = _ref4.token;
      return token('popout.padding.left', token('spacing.s', '.8rem'));
    },
    marginTop: function marginTop(_ref5) {
      var token = _ref5.token;
      return token('popout.margin.top', 0);
    },
    marginRight: function marginRight(_ref6) {
      var token = _ref6.token;
      return token('popout.margin.right', 0);
    },
    marginBottom: function marginBottom(_ref7) {
      var token = _ref7.token;
      return token('popout.margin.bottom', 0);
    },
    marginLeft: function marginLeft(_ref8) {
      var token = _ref8.token;
      return token('popout.margin.left', 0);
    },
    backgroundColor: function backgroundColor(_ref9) {
      var token = _ref9.token;
      return token('popout.background.color', token('color.container.static.default', 'white'));
    },
    minWidth: function minWidth(_ref10) {
      var token = _ref10.token;
      return token('popout.minWidth', 'auto');
    },
    maxWidth: function maxWidth(_ref11) {
      var token = _ref11.token;
      return token('popout.maxWidth', 'none');
    },
    borderRadius: function borderRadius(_ref12) {
      var token = _ref12.token;
      return token('popout.borderRadius', '.4rem');
    },
    filter: function filter(_ref13) {
      var token = _ref13.token;
      return token('popout.filter', // TODO: see how to pull out into token(s)
      "drop-shadow(0px 4px 12px rgba(34, 36, 42, 0.12)) " + "drop-shadow(0px 8px 16px rgba(34, 36, 42, 0.08)) " + "drop-shadow(0px 0px 2px #B9BBC6)");
    },
    zIndex: function zIndex(_ref14) {
      var token = _ref14.token;
      return token('popout.zIndex', token('zIndex.base', 0) + 1);
    },
    '&, & p': _objectSpread({}, text.styles({
      target: 'popout',
      fallback: 'normal.default',
      color: function color(_ref15) {
        var token = _ref15.token;
        return token('color.textStyle.body.default');
      }
    })),
    '& p': {
      paddingTop: 0,
      paddingBottom: function paddingBottom(_ref16) {
        var token = _ref16.token;
        return token('popout.paragraph.padding.bottom', token('spacing.xs', '.4rem'));
      },
      '&:last-child': {
        paddingBottom: 0
      }
    }
  },
  arrow: {
    position: 'absolute',
    transform: 'rotate(45deg)',
    background: function background(_ref17) {
      var token = _ref17.token;
      return token('popout.background.color', token('color.container.static.default', 'white'));
    },
    zIndex: 1
  },
  arrowTop: {
    bottom: function bottom(_ref18) {
      var token = _ref18.token;
      return token('popout.arrowSize', token('arrow.size', 12) / -2);
    }
  },
  arrowBottom: {
    top: function top(_ref19) {
      var token = _ref19.token;
      return token('popout.arrowSize', token('arrow.size', 12) / -2);
    }
  },
  arrowLeft: {
    right: function right(_ref20) {
      var token = _ref20.token;
      return token('popout.arrowSize', token('arrow.size', 12) / -2);
    }
  },
  arrowRight: {
    left: function left(_ref21) {
      var token = _ref21.token;
      return token('popout.arrowSize', token('arrow.size', 12) / -2);
    }
  },
  content: {
    position: 'relative',
    zIndex: 2,
    overflow: function overflow(_ref22) {
      var token = _ref22.token;
      return token('popout.content.overflow', 'auto');
    },
    maxHeight: function maxHeight(_ref23) {
      var token = _ref23.token;
      return token('popout.content.maxHeight', '90vh');
    },
    maxWidth: function maxWidth(_ref24) {
      var token = _ref24.token;
      return token('popout.content.maxHeight', '90vw');
    }
  }
});

function Popout(_ref25) {
  var id = _ref25.id,
      children = _ref25.children,
      _ref25$placement = _ref25.placement,
      placement = _ref25$placement === void 0 ? 'bottom' : _ref25$placement,
      distanceProp = _ref25.distance,
      s = _ref25.styles,
      _ref25$onToggle = _ref25.onToggle,
      onToggle = _ref25$onToggle === void 0 ? noop : _ref25$onToggle,
      Content = _ref25.Content;
  var token = useToken();
  var arrowSize = token('popout.arrowSize', token('arrow.size', 12));
  var distance = token('popout.distance', distanceProp || arrowSize / 2);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setOpen = _useState2[1];

  var child = Children.only(children);
  var toggle = useCallback(function () {
    setOpen(function (prevIsOpen) {
      return !prevIsOpen;
    });
  }, []);
  var contentClicked = useRef();

  function handleContentClick(e) {
    contentClicked.current = true;
  }

  useEffect(function () {
    onToggle(isOpen);
  }, [isOpen, onToggle]);
  useEffect(function () {
    function handleOutsideClick(e) {
      if (!contentClicked.current) {
        setOpen(false);
      }

      contentClicked.current = false;
    }

    function handleKeyDown(e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        setOpen(false);
      }
    }

    if (isOpen) {
      window.document.addEventListener('click', handleOutsideClick);
      window.document.addEventListener('keydown', handleKeyDown);
      return function () {
        window.document.removeEventListener('click', handleOutsideClick);
        window.document.removeEventListener('keydown', handleKeyDown);
      };
    }
  }, [children, id, isOpen]);
  return /*#__PURE__*/React.createElement(Manager, null, /*#__PURE__*/React.createElement(Reference, null, function (_ref26) {
    var ref = _ref26.ref;
    return /*#__PURE__*/cloneElement(child, {
      ref: ref,
      onClick: toggle,
      tabIndex: 0
    });
  }), /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement(Popper, {
    placement: placement,
    modifiers: {
      flip: {
        enabled: true,
        boundariesElement: 'viewport'
      },
      offset: {
        enabled: true,
        offset: "0, ".concat(distance)
      },
      preventOverflow: {
        enabled: true,
        boundariesElement: 'viewport'
      },
      hide: {
        enabled: true
      }
    }
  }, function (_ref27) {
    var placement = _ref27.placement,
        ref = _ref27.ref,
        style = _ref27.style,
        arrowProps = _ref27.arrowProps;
    return isOpen && /*#__PURE__*/React.createElement("div", _extends({
      ref: ref,
      "data-placement": placement,
      onClick: handleContentClick
    }, s.with('popout')(style)), /*#__PURE__*/React.createElement("div", _extends({}, arrowProps, s.with('arrow', {
      arrowTop: placement === null || placement === void 0 ? void 0 : _startsWithInstanceProperty(placement).call(placement, 'top'),
      arrowBottom: placement === null || placement === void 0 ? void 0 : _startsWithInstanceProperty(placement).call(placement, 'bottom'),
      arrowLeft: placement === null || placement === void 0 ? void 0 : _startsWithInstanceProperty(placement).call(placement, 'left'),
      arrowRight: placement === null || placement === void 0 ? void 0 : _startsWithInstanceProperty(placement).call(placement, 'right')
    })(_objectSpread(_objectSpread({}, arrowProps), {}, {
      width: arrowSize,
      height: arrowSize
    })))), /*#__PURE__*/React.createElement("div", s('content'), /*#__PURE__*/React.createElement(Content, {
      isOpen: isOpen,
      setOpen: setOpen,
      toggle: toggle
    })));
  }), window.document.body));
}

export default styled(defaultStyles)(Popout);